export default __webpack_public_path__ + "static/media/vanAllen.99eb85f1.gif";